export default __webpack_public_path__ + "static/media/PF_07.2e16c96a.png";